module.exports = __webpack_public_path__ + "img/img18.8ab94f7b.png";